import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {notification} from 'react-icons-kit/icomoon/notification';

var Config = require('../../../config');

class ModalReason extends Component{
	constructor(props){
		super(props);
	
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.saveReason = this.saveReason.bind(this);
		this.saveAuth = this.saveAuth.bind(this);

		this.state = {
			show: false,
			reason:"",
			reasons:[],
			detail:"",
			donation_number:"",
			message:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=reason_change_results&option=all&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      reasons: response
		    });
		})
	}

	handleShow(id, msg){
		this.setState({
			donation_number:id,
			show:true,
			message:msg
		});
	}

	handleClose(){
		this.setState({
			show: false,
			reason:"",
			detail:"",
			donation_number:"",
			message:""
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	saveReason(){
		var obj = {
			donation_number:this.state.donation_number,
			reason:this.state.reason,
			detail:this.state.detail
		}
		if(this.state.reason !== ""){
			this.props.auth(null, obj, 'laboratory');
		}else{
			swal('Error', 'Debe seleccionar un motivo', 'error');
		}
		
	}

	saveAuth(obj){
		this.props.waiting.handleShow('Guardando');
		fetch(Config.default.apiGateway.URL+'traceabilities/change_results',{
			method:'POST',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				//this.props.onSave();
				//setTimeout(()=>{
					this.handleClose();
				//}, 1000)
				
			}
		});
	}


	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title style={{textAlign:'center'}}>
		        		<SvgIcon size={90} icon={notification} style={{color:'orange'}}/>
		        	</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		<div className="col-xs-12">
		        			<h4 style={{textAlign:'center', color:'orange'}}>{this.state.message}</h4>		   
		        			<h5 style={{textAlign:'center', color:'orange'}}>{'¿DESEA CONTINUAR?'}</h5>		   
		        		</div>
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-4">
		        				<span>Motivo</span>
		        				<select className="form-control" name="reason" id="reason" value={this.state.reason} onChange={this.handleChange} required>
		        					<option value="">Seleccione...</option>
		        					{this.state.reasons.map((r, i)=>(
		        						<option key={i} value={r.name}>{r.name}</option>
		        					))}
		        				</select>
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			<div className="col-xs-12">
		        				<span>Detalles</span>
			        			<textarea className="form-control" style={{height:"200px",width:"100%",resize:"none"}} id="detail" name="detail"
			        				onChange={this.handleChange}>
			        			</textarea>
			        		</div>
		        		</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={'Continuar'} onClick={this.saveReason} />
		        	<FlatButton primary={true} label={'Cancelar'}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}

}

export default translate('translations') (ModalReason)